import {
  CarouselContainerWithScrollBar,
  SectionContainer,
  SliderSectionInner,
  TextContainer,
} from "components/rhombus-UI/theme/containers";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { trainingSessionSlide } from "./styles/rctp-styles";

import RhombusButton from "components/common/RhombusButton";
import TrainingEvent from "./TrainingEvent";
import { styled } from "@linaria/react";
import { Body, TitleMed } from "components/rui/typography";
import useGetRctpEvents from "./hooks/useGetRctpEvents";
import NotFound from "components/common/NotFound";

const SliderContainer = styled(CarouselContainerWithScrollBar)`
  @media (min-width: 1024px) {
    width: fit-content;
  }
`;

export default function UpComingTrainings() {
  const events = useGetRctpEvents(3);

  if (!events || events.length === 0)
    return <NotFound errorMessage={"No Upcoming RCTP Events"} />;

  return (
    <SectionContainer
      style={{
        paddingLeft: "0",
        paddingRight: "0",
      }}
    >
      <SliderSectionInner>
        <TextContainer
          style={{
            textAlign: "center",
            width: "931px",
            maxWidth: "calc(100% - 1.25rem)",
          }}
        >
          <TitleMed>Upcoming Trainings</TitleMed>
          <Body>
            Our RCTP trainings are held in multiple cities across the US and
            Canada. Find a session near you, RSVP today, and unlock the path to
            becoming a Rhombus security expert. Limited seats are available so
            don't wait.
          </Body>
        </TextContainer>
        <SliderContainer>
          <Swiper
            spaceBetween={40}
            slidesPerView={"auto"}
            breakpoints={{
              820: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
          >
            {events.map(event => {
              return (
                <SwiperSlide
                  className={trainingSessionSlide}
                  key={event.node.id}
                >
                  <TrainingEvent eventData={event} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </SliderContainer>
        <RhombusButton
          type="primary-dark"
          title={"View All Locations"}
          path={"/rctp/training-sessions"}
        />
      </SliderSectionInner>
    </SectionContainer>
  );
}
